// Site-wide content data (placeholder content — easily editable later)

export const BRAND = {
  name: 'BookMyZiyarah',
  tagline: 'Ziarat Concierge',
  fullName: 'BookMyZiyarah',
  domain: 'bookmyziyarah.org',
  whatsapp: '+9647862004840',
  whatsappPretty: '+964 786 200 4840',
  phone: '+9647862004840',
  email: 'reservations@bookmyziyarah.org',
  address: 'Bab Al-Qibla Boulevard, Karbala, Iraq',
  hotelName: 'Dar Al-Sakinah Boutique Hotel',
  hotelLocation: 'Karbala — 240 metres from Imam Hussain Holy Shrine',
};

export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'The Hotel', to: '/#hotel' },
  { label: 'Packages', to: '/packages' },
  { label: 'Visa', to: '/#visa' },
  { label: 'Transport', to: '/#transport' },
  { label: 'About', to: '/#about' },
  { label: 'Contact', to: '/contact' },
];

export const PILLARS = [
  {
    key: 'hotel',
    eyebrow: '01 — Stay',
    title: 'A Sanctuary in Karbala',
    body: 'Our boutique hotel rests two minutes from the holy shrine — designed for stillness, prayer, and restful nights.',
    image: 'https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?auto=format&fit=crop&w=1400&q=80',
  },
  {
    key: 'visa',
    eyebrow: '02 — Visa',
    title: 'Iraq Pilgrimage Visa',
    body: 'End-to-end visa concierge for pilgrims from every nation — paperwork, embassy liaison, status tracking, peace of mind.',
    image: 'https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&w=1400&q=85',
  },
  {
    key: 'transport',
    eyebrow: '03 — Transport',
    title: 'Private Drivers, Always',
    body: 'Airport transfers, intercity routes, day excursions — in clean late-model sedans, SUVs, and coaches with English-speaking drivers.',
    image: 'https://images.pexels.com/photos/36377058/pexels-photo-36377058.jpeg?auto=compress&cs=tinysrgb&w=1400',
  },
  {
    key: 'packages',
    eyebrow: '04 — Packages',
    title: 'The Complete Ziarat',
    body: 'Curated three- to seven-night journeys covering Karbala, Najaf, Kadhimiya, and Samarra — every detail orchestrated.',
    image: 'https://images.unsplash.com/photo-1601191362988-ac6ebec629c8?auto=format&fit=crop&w=1400&q=80',
  },
];

export const HOTEL = {
  name: 'Dar Al-Sakinah Boutique Hotel',
  rooms: [
    { name: 'Sakinah Deluxe Room', beds: '1 King', sleeps: 2, view: 'City', from: 110, image: 'https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?auto=format&fit=crop&w=1400&q=80' },
    { name: 'Shrine-View Suite', beds: '1 King + Lounge', sleeps: 3, view: 'Holy Shrine', from: 220, image: 'https://images.pexels.com/photos/97083/pexels-photo-97083.jpeg?auto=compress&cs=tinysrgb&w=1400' },
    { name: 'Family Residence', beds: '2 King + 1 Twin', sleeps: 5, view: 'Courtyard', from: 280, image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=80' },
  ],
  amenities: [
    'Walking distance to Imam Hussain Shrine',
    'Private prayer room with qibla orientation',
    '24-hour reception in English & Arabic',
    'In-house halal restaurant — Iraqi & Levantine',
    'Airport transfers from Najaf & Baghdad',
    'Daily ziyarat shuttle to Al-Abbas Shrine',
  ],
  gallery: [
    'https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=1800&q=85',
    'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1600&q=85',
    'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1600&q=85',
  ],
};

export const PACKAGES = [
  {
    slug: 'karbala-3-nights',
    name: 'Karbala — Three Nights of Stillness',
    nights: 3,
    region: 'karbala',
    from: 480,
    summary: 'A focused pilgrimage to the shrines of Imam Hussain and Hazrat Abbas, with unhurried mornings and guided evening ziyarat.',
    inclusions: ['3 nights at Dar Al-Sakinah', 'Najaf airport transfer (both ways)', 'Daily breakfast & one dinner', 'English-speaking shrine companion', 'Day visit to Karbala battlefield site'],
    image: 'https://images.unsplash.com/photo-1601191362988-ac6ebec629c8?auto=format&fit=crop&w=1600&q=80',
  },
  {
    slug: 'karbala-najaf-5-nights',
    name: 'Karbala & Najaf — Five-Night Pilgrimage',
    nights: 5,
    region: 'combined',
    from: 820,
    summary: 'The classical Ziarat — two nights in Najaf at the Shrine of Imam Ali, three nights in Karbala, with private transfers between cities.',
    inclusions: ['2 nights Najaf · 3 nights Karbala', 'Private sedan between cities', 'All shrine visits with companion', 'Wadi-us-Salam cemetery walk', 'Half-board dining (breakfast + dinner)'],
    image: 'https://images.unsplash.com/photo-1713239060784-e6ed820a0715?auto=format&fit=crop&w=1600&q=80',
  },
  {
    slug: 'complete-iraq-7-nights',
    name: 'The Complete Iraq — Seven Nights',
    nights: 7,
    region: 'combined',
    from: 1240,
    summary: 'A reverent seven-night journey across the four holy cities — Karbala, Najaf, Kadhimiya, and Samarra — designed for first-time and returning pilgrims alike.',
    inclusions: ['Stays in Karbala, Najaf & Baghdad', 'Visit to Al-Askari Shrine, Samarra', 'Kadhimiya & Baghdad heritage walk', 'All private intercity transfers', 'Daily breakfast, two formal dinners'],
    image: 'https://images.unsplash.com/photo-1567712595315-545da0d341b2?auto=format&fit=crop&w=1600&q=80',
  },
  {
    slug: 'najaf-essence-4-nights',
    name: 'Najaf — Four Nights at the Shrine of Ali',
    nights: 4,
    region: 'najaf',
    from: 690,
    summary: 'For those whose heart calls to Najaf — four unhurried nights beside the Shrine of Imam Ali, with quiet excursions to Kufa and the desert.',
    inclusions: ['4 nights in Najaf (partner riad)', 'Daily shrine visits', 'Half-day in Kufa', 'Najaf airport transfers', 'Calligraphy workshop (optional)'],
    image: 'https://images.unsplash.com/photo-1583158845212-c4a37b30f9bb?auto=format&fit=crop&w=1600&q=80',
  },
];

export const VISA_DOCS = [
  'Passport with 6 months validity & two blank pages',
  'Two recent passport-size photographs (white background)',
  'Confirmed hotel booking (we provide this on confirmation)',
  'Return / onward flight itinerary',
  'Yellow-fever vaccination certificate (for certain nationalities)',
];

export const VISA_STEPS = [
  { n: '01', t: 'Submit your details', d: 'Share scanned passport and travel dates through our concierge.' },
  { n: '02', t: 'Document preparation', d: 'We assemble the file, draft the cover letter, and book your sponsoring hotel night.' },
  { n: '03', t: 'Embassy submission', d: 'Lodged with the Iraq Consulate nearest you — or e-Visa where eligible.' },
  { n: '04', t: 'Receive your visa', d: 'Most pilgrim visas issue within 7 – 14 working days; rush options available.' },
];

export const TRANSPORT_FLEET = [
  { name: 'Executive Sedan', pax: 3, luggage: 3, image: 'https://images.pexels.com/photos/36377058/pexels-photo-36377058.jpeg?auto=compress&cs=tinysrgb&w=1400', detail: 'Late-model sedans for couples and business travellers — air-conditioned, English-speaking driver.' },
  { name: 'Family SUV', pax: 5, luggage: 5, image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1400&q=85', detail: 'Spacious SUVs for families and small groups, with abundant luggage capacity for the long pilgrimage.' },
  { name: 'Private Coach', pax: 14, luggage: 14, image: 'https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?auto=format&fit=crop&w=1400&q=85', detail: 'Premium minicoaches for extended families and small groups — ideal for the Karbala–Najaf–Samarra route.' },
];

export const TRANSPORT_ROUTES = [
  { from: 'Najaf Airport', to: 'Karbala Hotel', duration: '1h 20m', fromPrice: 55 },
  { from: 'Baghdad Airport', to: 'Karbala Hotel', duration: '2h 10m', fromPrice: 90 },
  { from: 'Karbala', to: 'Najaf', duration: '1h 10m', fromPrice: 60 },
  { from: 'Baghdad', to: 'Samarra (return)', duration: '5h round-trip', fromPrice: 180 },
];

export const TESTIMONIALS = [
  { quote: 'Every detail — from the visa to the shuttle to the prayer mat in the room — was held quietly in place. We only had to walk and to weep.', name: 'Fatima A.', origin: 'London, UK' },
  { quote: 'It is rare to feel so cared for in a place so far from home. Sahar Al-Iraq turned a pilgrimage into a homecoming.', name: 'Hassan M.', origin: 'Toronto, Canada' },
  { quote: 'The room overlooked the dome. At dawn the call to prayer arrived first, and the tea arrived second. I have not stopped thinking about it.', name: 'Zahra K.', origin: 'Sydney, Australia' },
];

export const FAQS = [
  { q: 'Who can apply for an Iraq pilgrimage visa?', a: 'Most nationalities are eligible. We have processed visas for travellers from the UK, US, Canada, EU, Australia, India, Pakistan, the GCC, and many African nations. Share your passport and we will confirm within 24 hours.' },
  { q: 'How close is the hotel to the holy shrine?', a: 'Dar Al-Sakinah is a 240-metre walk to the courtyard of the Imam Hussain Shrine — under three minutes on foot through the Bab Al-Qibla boulevard.' },
  { q: 'Do you arrange transport from Baghdad?', a: 'Yes. We offer private transfers from Baghdad International Airport in sedans, SUVs, and coaches. The journey to Karbala takes roughly two hours.' },
  { q: 'Are meals included in the packages?', a: 'All packages include a full breakfast daily. Most include one or more formal dinners at the hotel or at a partner restaurant. Vegetarian and halal-strict options are always available.' },
  { q: 'Can you accommodate large family groups?', a: 'Absolutely. Our Family Residence sleeps five, and adjoining rooms can be arranged. For groups above ten, we draft a custom itinerary with private coach transport.' },
  { q: 'What is your cancellation policy?', a: 'Inquiries are non-binding. Once a booking is confirmed, a 25% deposit is requested. Full refund up to 14 days before arrival; 50% refund within 14 – 7 days.' },
];

export const WHY_US = [
  { t: 'Family-owned in Karbala', d: 'Three generations of hospitality, rooted in the holy city — not a remote call-centre.' },
  { t: 'One concierge, end-to-end', d: 'The person who answers your first message is the person who hands you the key.' },
  { t: 'No hidden fees, ever', d: 'Quotes are all-inclusive. Taxes, transfers, and shrine fees are written into every package.' },
  { t: 'Available 24/7 in English & Arabic', d: 'WhatsApp, email, or phone — we answer at 3 a.m. in Najaf as readily as 3 p.m. in London.' },
];
